export const TaxonomyReconstructor = {
    reconstruct: (presData, defData, calcData) => {
        const fullPot = [];
        const concepts = {};
        const roots = [];
        const financeMap = {};
        const stack = [];

        // 1. DYNAMIC INDEX MAPPING (Zero Hardcoding in Loops)
        const cMap = calcData.colMap;
        const pMap = presData.colMap;

        // 2. THE FINANCE OVERLAY (Sandbox Step 1)
        calcData.rows.slice(1).forEach(row => {
            // Dynamically lookup the "Technical Name" column index
            const techName = row[cMap["Technical Name"]]; 
            if (techName) {
                financeMap[techName] = {
                    weight: row[cMap["Weight"]],
                    format: row[cMap["Type name short"]],
                    balance: row[cMap["Balance"]],
                    references: row[cMap["References"]]
                };
            }
        });

        // 3. THE MASTER JOIN (Sandbox Step 2: Pure Relational)
        presData.rows.slice(1).forEach((row, index) => {
            const id = row[pMap["Technical Name"]];
            const level = parseInt(row[pMap["Level"]]);
            const roleRaw = String(row[pMap["Role"]] || "");
            
            if (!id) return;

            // Generate Unique Instance Key using row index to prevent de-duplication
            const nodeUid = `${id}_${index}`;
            const mathMatch = financeMap[id];

            const node = {
                uid: nodeUid,
                technical_id: id,
                role_id: roleRaw.match(/\[(.*?)\]/)?.[1] || "NA",
                business_chapter: roleRaw.replace(/\[.*?\]/, '').trim(),
                label: row[pMap["Label en"]],
                level: level,
                is_abstract: String(row[pMap["Abstract"]] || "").toLowerCase() === 'true',
                finance_logic: mathMatch ? {
                    weight: mathMatch.weight,
                    format: mathMatch.format,
                    balance: mathMatch.balance
                } : null,
                legal_reference: mathMatch ? mathMatch.references : (row[pMap["References"]] || null),
                children: [] 
            };

            // Every single row goes into the pot (Identical to Sandbox parity)
            fullPot.push(node);
            concepts[nodeUid] = node;

            // Nesting for the Tree Viewer (matches Workflow_Hub requirement)
            if (level === 1) {
                roots.push(nodeUid);
            } else {
                const parent = stack[level - 2];
                if (parent) {
                    parent.children.push(nodeUid);
                }
            }
            
            stack[level - 1] = node;
            stack.length = level;
        });

        // 4. RETURN FOR Workflow_Validation_View.jsx
        // This structure ensures results.esgTree is NOT undefined
        return {
            worksheets: [
                { name: "Presentation", rowCount: presData.rows.length },
                { name: "Calculation", rowCount: calcData.rows.length }
            ],
            esgTree: {
                fullPot,   // The raw JSON dump for the black box
                concepts,  // The unique instance map
                roots      // Level 1 Entry points
            }
        };
    }
};